import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, Input, Output, NgModule } from '@angular/core';
import DxSortable from 'devextreme/ui/sortable';
import * as i1 from 'devextreme-angular/core';
import { DxComponent, DxTemplateHost, WatcherHelper, NestedOptionHost, DxIntegrationModule, DxTemplateModule } from 'devextreme-angular/core';
import { DxoCursorOffsetModule } from 'devextreme-angular/ui/nested';
import { DxoSortableCursorOffsetModule } from 'devextreme-angular/ui/sortable/nested';
const _c0 = ["*"];
export * from 'devextreme-angular/ui/sortable/nested';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/**
 * Sortable is a user interface utility that allows a UI component&apos;s items to be reordered via drag and drop gestures.

 */
let DxSortableComponent = /*#__PURE__*/(() => {
  class DxSortableComponent extends DxComponent {
    instance = null;
    /**
     * Allows a user to drop an item inside another item.
    
     */
    get allowDropInsideItem() {
      return this._getOption('allowDropInsideItem');
    }
    set allowDropInsideItem(value) {
      this._setOption('allowDropInsideItem', value);
    }
    /**
     * Allows a user to reorder sortable items.
    
     */
    get allowReordering() {
      return this._getOption('allowReordering');
    }
    set allowReordering(value) {
      this._setOption('allowReordering', value);
    }
    /**
     * Enables automatic scrolling while dragging an item beyond the viewport.
    
     */
    get autoScroll() {
      return this._getOption('autoScroll');
    }
    set autoScroll(value) {
      this._setOption('autoScroll', value);
    }
    /**
     * Specifies a DOM element that limits the dragging area.
    
     */
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    /**
     * Specifies a custom container in which the draggable item should be rendered.
    
     */
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    /**
     * Specifies the cursor offset from the dragged item.
    
     */
    get cursorOffset() {
      return this._getOption('cursorOffset');
    }
    set cursorOffset(value) {
      this._setOption('cursorOffset', value);
    }
    /**
     * A container for custom data.
    
     */
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    /**
     * Specifies the directions in which an item can be dragged.
    
     */
    get dragDirection() {
      return this._getOption('dragDirection');
    }
    set dragDirection(value) {
      this._setOption('dragDirection', value);
    }
    /**
     * Specifies custom markup to be shown instead of the item being dragged.
    
     */
    get dragTemplate() {
      return this._getOption('dragTemplate');
    }
    set dragTemplate(value) {
      this._setOption('dragTemplate', value);
    }
    /**
     * Specifies how to highlight the item&apos;s drop position.
    
     */
    get dropFeedbackMode() {
      return this._getOption('dropFeedbackMode');
    }
    set dropFeedbackMode(value) {
      this._setOption('dropFeedbackMode', value);
    }
    /**
     * Specifies the global attributes to be attached to the UI component&apos;s container element.
    
     */
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    /**
     * Specifies a CSS selector for the items that can be dragged.
    
     */
    get filter() {
      return this._getOption('filter');
    }
    set filter(value) {
      this._setOption('filter', value);
    }
    /**
     * Allows you to group several UI components, so that users can drag and drop items between them.
    
     */
    get group() {
      return this._getOption('group');
    }
    set group(value) {
      this._setOption('group', value);
    }
    /**
     * Specifies a CSS selector (ID or class) that should act as the drag handle(s) for the item(s).
    
     */
    get handle() {
      return this._getOption('handle');
    }
    set handle(value) {
      this._setOption('handle', value);
    }
    /**
     * Specifies the UI component&apos;s height.
    
     */
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    /**
     * Notifies the UI component of the items&apos; orientation.
    
     */
    get itemOrientation() {
      return this._getOption('itemOrientation');
    }
    set itemOrientation(value) {
      this._setOption('itemOrientation', value);
    }
    /**
     * Moves an element in the HTML markup when it is dropped.
    
     */
    get moveItemOnDrop() {
      return this._getOption('moveItemOnDrop');
    }
    set moveItemOnDrop(value) {
      this._setOption('moveItemOnDrop', value);
    }
    /**
     * Switches the UI component to a right-to-left representation.
    
     */
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    /**
     * Specifies the distance in pixels from the edge of viewport at which scrolling should start. Applies only if autoScroll is true.
    
     */
    get scrollSensitivity() {
      return this._getOption('scrollSensitivity');
    }
    set scrollSensitivity(value) {
      this._setOption('scrollSensitivity', value);
    }
    /**
     * Specifies the scrolling speed when dragging an item beyond the viewport. Applies only if autoScroll is true.
    
     */
    get scrollSpeed() {
      return this._getOption('scrollSpeed');
    }
    set scrollSpeed(value) {
      this._setOption('scrollSpeed', value);
    }
    /**
     * Specifies the UI component&apos;s width.
    
     */
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * A function that is called when a new item is added.
    
    
     */
    onAdd;
    /**
    
     * A function that is executed before the UI component is disposed of.
    
    
     */
    onDisposing;
    /**
    
     * A function that is called when the dragged item&apos;s position in the list is changed.
    
    
     */
    onDragChange;
    /**
    
     * A function that is called when the drag gesture is finished.
    
    
     */
    onDragEnd;
    /**
    
     * A function that is called every time a draggable item is moved.
    
    
     */
    onDragMove;
    /**
    
     * A function that is called when a drag gesture is initialized.
    
    
     */
    onDragStart;
    /**
    
     * A function used in JavaScript frameworks to save the UI component instance.
    
    
     */
    onInitialized;
    /**
    
     * A function that is executed after a UI component property is changed.
    
    
     */
    onOptionChanged;
    /**
    
     * A function that is called when a draggable item is removed.
    
    
     */
    onRemove;
    /**
    
     * A function that is called when the draggable items are reordered.
    
    
     */
    onReorder;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    allowDropInsideItemChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    allowReorderingChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    autoScrollChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    boundaryChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    containerChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    cursorOffsetChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dataChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dragDirectionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dragTemplateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dropFeedbackModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    elementAttrChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    filterChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    groupChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    handleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemOrientationChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    moveItemOnDropChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    rtlEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    scrollSensitivityChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    scrollSpeedChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    constructor(elementRef, ngZone, templateHost, _watcherHelper, optionHost, transferState, platformId) {
      super(elementRef, ngZone, templateHost, _watcherHelper, transferState, platformId);
      this._createEventEmitters([{
        subscribe: 'add',
        emit: 'onAdd'
      }, {
        subscribe: 'disposing',
        emit: 'onDisposing'
      }, {
        subscribe: 'dragChange',
        emit: 'onDragChange'
      }, {
        subscribe: 'dragEnd',
        emit: 'onDragEnd'
      }, {
        subscribe: 'dragMove',
        emit: 'onDragMove'
      }, {
        subscribe: 'dragStart',
        emit: 'onDragStart'
      }, {
        subscribe: 'initialized',
        emit: 'onInitialized'
      }, {
        subscribe: 'optionChanged',
        emit: 'onOptionChanged'
      }, {
        subscribe: 'remove',
        emit: 'onRemove'
      }, {
        subscribe: 'reorder',
        emit: 'onReorder'
      }, {
        emit: 'allowDropInsideItemChange'
      }, {
        emit: 'allowReorderingChange'
      }, {
        emit: 'autoScrollChange'
      }, {
        emit: 'boundaryChange'
      }, {
        emit: 'containerChange'
      }, {
        emit: 'cursorOffsetChange'
      }, {
        emit: 'dataChange'
      }, {
        emit: 'dragDirectionChange'
      }, {
        emit: 'dragTemplateChange'
      }, {
        emit: 'dropFeedbackModeChange'
      }, {
        emit: 'elementAttrChange'
      }, {
        emit: 'filterChange'
      }, {
        emit: 'groupChange'
      }, {
        emit: 'handleChange'
      }, {
        emit: 'heightChange'
      }, {
        emit: 'itemOrientationChange'
      }, {
        emit: 'moveItemOnDropChange'
      }, {
        emit: 'rtlEnabledChange'
      }, {
        emit: 'scrollSensitivityChange'
      }, {
        emit: 'scrollSpeedChange'
      }, {
        emit: 'widthChange'
      }]);
      optionHost.setHost(this);
    }
    _createInstance(element, options) {
      return new DxSortable(element, options);
    }
    ngOnDestroy() {
      this._destroyWidget();
    }
    /** @nocollapse */
    static ɵfac = function DxSortableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxSortableComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.DxTemplateHost), i0.ɵɵdirectiveInject(i1.WatcherHelper), i0.ɵɵdirectiveInject(i1.NestedOptionHost), i0.ɵɵdirectiveInject(i0.TransferState), i0.ɵɵdirectiveInject(PLATFORM_ID));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxSortableComponent,
      selectors: [["dx-sortable"]],
      hostAttrs: ["ngSkipHydration", "true"],
      inputs: {
        allowDropInsideItem: "allowDropInsideItem",
        allowReordering: "allowReordering",
        autoScroll: "autoScroll",
        boundary: "boundary",
        container: "container",
        cursorOffset: "cursorOffset",
        data: "data",
        dragDirection: "dragDirection",
        dragTemplate: "dragTemplate",
        dropFeedbackMode: "dropFeedbackMode",
        elementAttr: "elementAttr",
        filter: "filter",
        group: "group",
        handle: "handle",
        height: "height",
        itemOrientation: "itemOrientation",
        moveItemOnDrop: "moveItemOnDrop",
        rtlEnabled: "rtlEnabled",
        scrollSensitivity: "scrollSensitivity",
        scrollSpeed: "scrollSpeed",
        width: "width"
      },
      outputs: {
        onAdd: "onAdd",
        onDisposing: "onDisposing",
        onDragChange: "onDragChange",
        onDragEnd: "onDragEnd",
        onDragMove: "onDragMove",
        onDragStart: "onDragStart",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onRemove: "onRemove",
        onReorder: "onReorder",
        allowDropInsideItemChange: "allowDropInsideItemChange",
        allowReorderingChange: "allowReorderingChange",
        autoScrollChange: "autoScrollChange",
        boundaryChange: "boundaryChange",
        containerChange: "containerChange",
        cursorOffsetChange: "cursorOffsetChange",
        dataChange: "dataChange",
        dragDirectionChange: "dragDirectionChange",
        dragTemplateChange: "dragTemplateChange",
        dropFeedbackModeChange: "dropFeedbackModeChange",
        elementAttrChange: "elementAttrChange",
        filterChange: "filterChange",
        groupChange: "groupChange",
        handleChange: "handleChange",
        heightChange: "heightChange",
        itemOrientationChange: "itemOrientationChange",
        moveItemOnDropChange: "moveItemOnDropChange",
        rtlEnabledChange: "rtlEnabledChange",
        scrollSensitivityChange: "scrollSensitivityChange",
        scrollSpeedChange: "scrollSpeedChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([DxTemplateHost, WatcherHelper, NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxSortableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxSortableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxSortableModule = /*#__PURE__*/(() => {
  class DxSortableModule {
    /** @nocollapse */static ɵfac = function DxSortableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxSortableModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxSortableModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxSortableComponent, DxoCursorOffsetModule, DxoSortableCursorOffsetModule, DxIntegrationModule, DxTemplateModule, DxoCursorOffsetModule, DxoSortableCursorOffsetModule, DxTemplateModule]
    });
  }
  return DxSortableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DxSortableComponent, DxSortableModule };
